import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a056704"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "editor-shell"
};
const _hoisted_2 = {
  class: "basic-fields"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "optical-title"
}, "题干", -1));
const _hoisted_4 = {
  class: "tool-strip",
  "aria-label": "光路配置工具栏"
};
const _hoisted_5 = {
  class: "tool-group"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tool-label"
}, "元件", -1));
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "tool-group"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tool-label"
}, "光线颜色", -1));
const _hoisted_10 = ["aria-label", "onClick"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "interaction-help"
}, "点击方格放置元件。点击边缘空位添加射入箭头，再次点击切换为射出；选择其他颜色后点击可改色，使用“清除”删除。", -1));
const _hoisted_12 = {
  class: "editor-section layout-section"
};
const _hoisted_13 = {
  class: "section-copy"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "仪器内部元件", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "每格最多放置一个元件。该布局在学生答题时隐藏，答后回看时显示。", -1));
const _hoisted_16 = {
  class: "layout-status"
};
const _hoisted_17 = {
  class: "board-stage"
};
const _hoisted_18 = {
  class: "section-heading"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "已知射入射出案例"), /*#__PURE__*/_createElementVNode("p", null, "每个案例至少配置一条射入光线和一条射出光线，最多 8 个案例。")], -1));
const _hoisted_20 = {
  class: "case-grid"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "target-section"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-copy"
}, [/*#__PURE__*/_createElementVNode("h3", null, "新射入路径"), /*#__PURE__*/_createElementVNode("p", null, "这里只配置射入光线，射出结果由学生从 A-D 中选择。")], -1));
const _hoisted_24 = {
  class: "board-stage compact-stage"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-heading option-heading"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "射出路径选项"), /*#__PURE__*/_createElementVNode("p", null, "每个选项只配置射出光线。")])], -1));
const _hoisted_26 = {
  class: "option-grid"
};
const _hoisted_27 = {
  class: "answer-section"
};
const _hoisted_28 = {
  class: "answer-field"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "正确答案", -1));
const _hoisted_30 = {
  class: "answer-field"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "optical-analysis"
}, "解析文字（可选）", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_OpticalPathBoard = _resolveComponent("OpticalPathBoard");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    class: "optical-editor-dialog",
    "model-value": $props.visible,
    title: $props.question?.id ? '编辑黑盒光路题' : '新增黑盒光路题',
    width: "1180px",
    top: "4vh",
    "destroy-on-close": "",
    "append-to-body": "",
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.$emit('update:visible', $event))
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      onClick: _cache[7] || (_cache[7] = $event => _ctx.$emit('update:visible', false))
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      loading: $data.saving,
      onClick: $options.save
    }, {
      default: _withCtx(() => [_createTextVNode("保存题目")]),
      _: 1
    }, 8, ["loading", "onClick"])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
      id: "optical-title",
      modelValue: $data.draft.title,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.draft.title = $event),
      maxlength: "100",
      "show-word-limit": ""
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.elementTools, tool => {
      return _openBlock(), _createElementBlock("button", {
        key: tool.value,
        type: "button",
        class: _normalizeClass(["tool-button", {
          active: $data.activeTool === tool.value
        }]),
        onClick: $event => $data.activeTool = tool.value
      }, [_createElementVNode("span", {
        class: _normalizeClass(["tool-symbol", tool.value])
      }, null, 2), _createTextVNode(" " + _toDisplayString(tool.label), 1)], 10, _hoisted_7);
    }), 128)), _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["tool-button erase", {
        active: $data.activeTool === 'eraser'
      }]),
      onClick: _cache[1] || (_cache[1] = $event => $data.activeTool = 'eraser')
    }, " 清除 ", 2)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arrowColors, color => {
      return _openBlock(), _createElementBlock("button", {
        key: color.value,
        type: "button",
        class: _normalizeClass(["color-button", [`color-${color.value}`, {
          active: $data.arrowColor === color.value
        }]]),
        "aria-label": color.label,
        onClick: $event => {
          $data.arrowColor = color.value;
          $data.activeTool = $data.activeTool === 'eraser' ? 'filter-red' : $data.activeTool;
        }
      }, null, 10, _hoisted_10);
    }), 128))])]), _hoisted_11, _createVNode(_component_el_tabs, {
      modelValue: $data.activeTab,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.activeTab = $event),
      class: "editor-tabs"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "内部结构",
        name: "layout"
      }, {
        default: _withCtx(() => [_createElementVNode("section", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("div", _hoisted_16, "已放置 " + _toDisplayString($options.elementCount) + " 个元件", 1)]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_OpticalPathBoard, {
          modelValue: $data.draft.opticalConfig.layout,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.draft.opticalConfig.layout = $event),
          "editable-cells": true,
          "show-arrow-slots": false,
          "active-tool": $data.activeTool,
          "aria-label": "仪器内部元件布局"
        }, null, 8, ["modelValue", "active-tool"])])])]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "已知案例",
        name: "cases"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          disabled: $data.draft.opticalConfig.cases.length >= 8,
          onClick: $options.addCase
        }, {
          default: _withCtx(() => [_createTextVNode("新增案例")]),
          _: 1
        }, 8, ["disabled", "onClick"])]), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.draft.opticalConfig.cases, (knownCase, index) => {
          return _openBlock(), _createElementBlock("article", {
            key: index,
            class: "board-card"
          }, [_createElementVNode("header", null, [_createElementVNode("strong", null, "案例 " + _toDisplayString(index + 1), 1), $data.draft.opticalConfig.cases.length > 1 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "remove-button",
            onClick: $event => $options.removeCase(index)
          }, "删除", 8, _hoisted_21)) : _createCommentVNode("", true)]), _createVNode(_component_OpticalPathBoard, {
            modelValue: $data.draft.opticalConfig.cases[index],
            "onUpdate:modelValue": $event => $data.draft.opticalConfig.cases[index] = $event,
            compact: "",
            "show-elements": false,
            "editable-arrows": true,
            "active-tool": $data.activeTool,
            "arrow-color": $data.arrowColor,
            "aria-label": `已知案例 ${index + 1}`
          }, null, 8, ["modelValue", "onUpdate:modelValue", "active-tool", "arrow-color", "aria-label"])]);
        }), 128))])]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "新路径与选项",
        name: "options"
      }, {
        default: _withCtx(() => [_createElementVNode("section", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createVNode(_component_OpticalPathBoard, {
          modelValue: $data.draft.opticalConfig.target,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.draft.opticalConfig.target = $event),
          compact: "",
          "show-elements": false,
          "editable-arrows": true,
          "active-tool": $data.activeTool,
          "arrow-color": $data.arrowColor,
          "aria-label": "新射入路径"
        }, null, 8, ["modelValue", "active-tool", "arrow-color"])])]), _hoisted_25, _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.draft.opticalConfig.options, (option, index) => {
          return _openBlock(), _createElementBlock("article", {
            key: index,
            class: "board-card option-card"
          }, [_createElementVNode("header", null, [_createElementVNode("strong", null, _toDisplayString($data.optionLetters[index]), 1)]), _createVNode(_component_OpticalPathBoard, {
            modelValue: $data.draft.opticalConfig.options[index],
            "onUpdate:modelValue": $event => $data.draft.opticalConfig.options[index] = $event,
            compact: "",
            "show-elements": false,
            "editable-arrows": true,
            "active-tool": $data.activeTool,
            "arrow-color": $data.arrowColor,
            "aria-label": `选项 ${$data.optionLetters[index]}`
          }, null, 8, ["modelValue", "onUpdate:modelValue", "active-tool", "arrow-color", "aria-label"])]);
        }), 128))])]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "答案与解析",
        name: "answer"
      }, {
        default: _withCtx(() => [_createElementVNode("section", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createVNode(_component_el_radio_group, {
          modelValue: $data.draft.rightAnswer,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.draft.rightAnswer = $event)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.optionLetters, letter => {
            return _openBlock(), _createBlock(_component_el_radio_button, {
              key: letter,
              label: letter
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(letter), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createVNode(_component_el_input, {
          id: "optical-analysis",
          modelValue: $data.draft.analysisText,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.draft.analysisText = $event),
          type: "textarea",
          rows: 5,
          maxlength: "1000",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])])])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  }, 8, ["model-value", "title"]);
}